import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=4b2d0f0b&scoped=true&"
import script from "./not-found.vue?vue&type=script&lang=js&"
export * from "./not-found.vue?vue&type=script&lang=js&"
import style0 from "./not-found.vue?vue&type=style&index=0&id=4b2d0f0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d0f0b",
  null
  
)

export default component.exports